<template>
  <el-dialog title="会员缴费" :visible.sync="visible" width="500px" @close="$emit('close')">
    <div class="payment-content">
      <div class="payment-item">
        <!-- 开通时长选择 -->
        <div class="duration-select">
          <p>开通时长：</p>
          <div>
            <el-radio-group v-model="selectedDuration" @change="updateAmount">
              <el-radio :label="1" border style="margin-right: 10px;">1年</el-radio>
              <el-radio :label="2" border style="margin-right: 10px;">2年</el-radio>
              <el-radio :label="3" border>3年</el-radio>
            </el-radio-group>
            <div class="duration-range">{{ durationRange }}</div>
          </div>
        </div>

        <!-- 支付方式选择 -->
        <div class="payment-method">
          <p>支付方式：</p>
          <el-radio-group v-model="paymentMethod">
            <el-radio-button label="wechat">微信支付</el-radio-button>
          </el-radio-group>
        </div>

        <p class="amount">支付金额：<span>{{ amount }}元</span></p>

        <!-- 二维码显示区域 -->
        <div v-if="showQRCode" class="qrcode-container">
          <p class="scan-tip">请使用微信扫描二维码完成支付</p>
          <div class="qrcode-wrapper" v-loading="qrLoading">
            <div class="image-qrcode" id="image" ref="qrcode"></div>
          </div>
          <p class="expire-time" v-if="expireTime">二维码有效期至: {{ expireTime }}</p>
        </div>

        <div style="display: flex; justify-content: center;">
          <el-button type="primary" @click="initiatePayment" :loading="loading" v-if="!showQRCode" style="margin-top: 20px;color: #FFF">
            立即支付
          </el-button>

          <el-button type="text" @click="cancelPayment" v-if="showQRCode" style="margin-top: 15px">
            取消支付
          </el-button>
        </div>
      </div>

      <div class="payment-notice">
        <p>关于上海卒中学会会员缴纳</p>
        <ul>
          <li>普通会员会费标准：50元/人/年；</li>
          <li>〔会费缴费时间及其他要求〕上海卒中学会所设各类会员均在每年4月缴纳当年会费。如各类会员一年不缴纳会费、不参加学会组织的活动，按自动退会处理。最终解释权归上海卒中学会。</li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { createWechatOrder, getOrderStatus } from '../../../http/request';
import QRCode from 'qrcodejs2';

export default {
  name: 'PayDialog',
  data() {
    return {
      visible: false,
      loading: false,
      qrLoading: false,
      showQRCode: false,
      qrcodeUrl: '',
      expireTime: '',
      orderNo: '',
      checkTimer: null,
      paymentSuccess: false,
      selectedDuration: 1, // 默认选择1年
      paymentMethod: 'wechat', // 默认微信支付
      amount: 50, // 默认1年50元
      qrcodeInstance: null, // 保存QRCode实例
      startDate: '', // 开始日期
      endDate: '' // 结束日期
    };
  },
  computed: {
    durationRange() {
      if (this.startDate && this.endDate) {
        return `${this.startDate} 至 ${this.endDate}`;
      }
      return '请选择开通时长';
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.updateDurationRange();
    },

    handleClose() {
      this.clearTimer();
      this.resetDialog();
    },

    resetDialog() {
      this.showQRCode = false;
      this.qrcodeUrl = '';
      this.expireTime = '';
      this.orderNo = '';
      this.paymentSuccess = false;
      this.selectedDuration = 1;
      this.paymentMethod = 'wechat';
      this.amount = 50;
      this.startDate = '';
      this.endDate = '';
      // 清除已有的二维码
      if (this.qrcodeInstance) {
        this.qrcodeInstance.clear();
        this.qrcodeInstance = null;
      }
    },

    clearTimer() {
      if (this.checkTimer) {
        clearInterval(this.checkTimer);
        this.checkTimer = null;
      }
    },

    updateAmount() {
      if (this.selectedDuration === 1) {
        this.amount = 50;
      } else if (this.selectedDuration === 2) {
        this.amount = 100;
      } else {
        this.amount = 150;
      }
      this.updateDurationRange();
    },

    updateDurationRange() {
      const today = new Date();
      this.startDate = this.formatDate(today);
      const endDate = new Date(today);
      endDate.setFullYear(endDate.getFullYear() + this.selectedDuration);
      this.endDate = this.formatDate(endDate);
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1);
      const day = this.padZero(date.getDate());
      return `${year}-${month}-${day}`;
    },

    padZero(num) {
      return num < 10 ? `0${num}` : num;
    },

    async initiatePayment() {
      this.loading = true;
      try {
        const { data: res } = await createWechatOrder(this.selectedDuration);
        if (res.code === 0) {
          this.orderNo = res.data.orderNo;
          this.qrcodeUrl = res.data.codeUrl;
          this.expireTime = this.formatTime(res.data.expireTime);
          this.showQRCode = true;

          // 使用$nextTick确保DOM已经更新
          this.$nextTick(() => {
            this.generateQRCode();
          });

          this.startPaymentStatusCheck();
        } else {
          this.$message.error(res.msg || '创建支付订单失败');
        }
      } catch (error) {
        console.error('支付出错:', error);
        this.$message.error('创建支付订单过程中出现错误');
      } finally {
        this.loading = false;
      }
    },

    generateQRCode() {
      this.qrLoading = true;
      try {
        // 清除已有的二维码
        if (this.qrcodeInstance) {
          this.qrcodeInstance.clear();
        }

        // 确保DOM元素存在
        if (this.$refs.qrcode) {
          this.$refs.qrcode.innerHTML = '';
          this.qrcodeInstance = new QRCode(this.$refs.qrcode, {
            text: this.qrcodeUrl,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      } catch (error) {
        console.error('生成二维码失败:', error);
        this.$message.error('生成支付二维码失败');
      } finally {
        this.qrLoading = false;
      }
    },

    startPaymentStatusCheck() {
      this.clearTimer();
      this.checkTimer = setInterval(() => {
        this.getOrderStatus();
      }, 3000);
    },

    async getOrderStatus() {
      if (!this.orderNo) return;

      try {
        const { data: res } = await getOrderStatus(this.orderNo);

        if (res.code === 0) {
          if (res.data) {
            this.paymentSuccess = true;
            this.clearTimer();
            this.$message.success('支付成功！');
            this.visible = false
            this.handleClose();
            this.$emit('payment-success');
          }
        }
      } catch (error) {
        this.clearTimer();
        this.$message.warning('支付已关闭，请重新发起支付');
        this.resetDialog();
      }
    },

    cancelPayment() {
      this.$confirm('确定要取消本次支付吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearTimer();
        this.resetDialog();
      }).catch(() => { });
    },

    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())} ${this.padZero(date.getHours())}:${this.padZero(date.getMinutes())}`;
    }
  },
  beforeDestroy() {
    this.clearTimer();
    // 清除二维码实例
    if (this.qrcodeInstance) {
      this.qrcodeInstance.clear();
    }
  }
};
</script>

<style scoped>
.payment-content {
  padding: 0 20px;
}

.payment-item {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.payment-item p {
  margin: 10px 0;
  color: #666;
}

.duration-select,
.payment-method {
  display: flex;
  margin-bottom: 15px;
}

.duration-select p,
.payment-method p {
  margin-right: 15px;
  margin-bottom: 0;
}

.duration-range {
  padding: 10px 0 0 0;
  color: #409eff;
  font-weight: bold;
  margin-left: 5px;
}

.duration-range p {
  margin: 0;
  font-size: 14px;
  color: #333;
}

.amount span {
  color: #f56c6c;
  font-weight: bold;
  font-size: 18px;
}

.qrcode-container {
  margin-top: 20px;
  text-align: center;
}

.scan-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.qrcode-wrapper {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ddd;
  padding: 10px;
}

.empty-qrcode {
  text-align: center;
  color: #999;
}

.empty-qrcode i {
  font-size: 40px;
  margin-bottom: 10px;
}

.expire-time {
  font-size: 12px;
  color: #f56c6c;
  margin-top: 10px;
}

.payment-notice {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.payment-notice ul {
  padding-left: 20px;
  margin-top: 10px;
}

.payment-notice li {
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>